/** Login types */
export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST"
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS"
export const FETCH_LOGIN_FAIL = "FETCH_LOGIN_FAIL"
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS"
export const CLOSE_DETAILS = "CLOSE_DETAILS"
export const SHOW_DETAILS = "SHOW_DETAILS"
// reset password
export const FETCH_FORGET_SUCCESS = "FETCH_FORGET_SUCCESS"
export const FETCH_EMAIL_REQUEST = "FETCH_EMAIL_REQUEST"
export const FETCH_EMAIL_SUCCESS = "FETCH_EMAIL_SUCCESS"
export const FETCH_EMAIL_FAIL = "FETCH_EMAIL_SUCCESS"

export const FETCH_CODE_REQUEST = "FETCH_CODE_REQUEST"
export const FETCH_CODE_SUCCESS = "FETCH_CODE_SUCCESS"
export const FETCH_CODE_FAIL = "FETCH_CODE_FAIL"


export const FETCH_RESET_REQUEST = "FETCH_RESET_REQUEST"
export const FETCH_RESET_SUCCESS = "FETCH_RESET_SUCCESS"
export const FETCH_RESET_FAIL = "FETCH_RESET_SUCCESS"

export const FETCH_SET_PASSWORD_SUCCESS = "FETCH_SET_PASSWORD_SUCCESS"

/** All Products */
export const FETCH_PRODUCT_REQUEST = "FETCH_PRODUCT_REQUEST"
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS"
export const FETCH_PRODUCT_FAIL = "FETCH_PRODUCT_FAIL"
export const REMOVE_PRODUCT = "REMOVE_PRODUCT"
export const ADD_PRODUCT_REQUEST = " ADD_PRODUCT_REQUEST"
export const ADD_PRODUCTOFFER_REQUEST = "ADD_PRODUCTOFFER_REQUEST"
export const INITIALIZE_PRODUCT = "INITIALIZE_PRODUCT"
export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST"
export const FETCH_PRODUCTBYID_REQUEST = "FETCH_PRODUCTBYID_REQUEST"
export const FETCH_PRODUCTBYID_FAIL = "FETCH_PRODUCTBYID_FAIL"
export const FETCH_PRODUCTBYID_SUCCESS = "FETCH_PRODUCTBYID_SUCCESS"
export const FETCH_REPLIES_REQUEST = "FETCH_REPLIES_REQUEST"
export const FETCH_REPLIES_FAIL = "FETCH_REPLIES_FAIL"
export const FETCH_REPLIES_SUCCESS = "FETCH_REPLIES_SUCCESS"
export const ADD_REPLY_REQUEST = " ADD_REPLY_REQUEST "
export const ARRANGIMAGES_PRODUCT_REQUEST = "ARRANGIMAGES_PRODUCT_REQUEST"
export const UPDATECOUNTS_REQUEST = "UPDATECOUNTS_REQUEST"
export const FETCH_TRADER_PRODUCT_REQUEST = "FETCH_TRADER_PRODUCT_REQUEST"
export const FETCH_TRADER_PRODUCT_SUCCESS = "FETCH_TRADER_PRODUCT_SUCCESS"
export const FETCH_TRADER_PRODUCT_FAIL = "FETCH_TRADER_PRODUCT_FAIL"
export const REMOVE_TRADER_PRODUCT = " REMOVE_TRADER_PRODUCT"



//Language
export const FETCH_Lang_REQUEST = "FETCH_Lang_REQUEST"
export const FETCH_SIDEMENU_REQUEST = "FETCH_SIDEMENU_REQUEST"
export const INTIALIZE_TOKEN="INTIALIZE_TOKEN"
export const INTIALIZE="INTIALIZE"
export const REMOVE_TOKEN="REMOVE_TOKEN"
// Ather Socket/////
export const UPDATE_FINANCED_ORDER="UPDATE_FINANCED_ORDER"
export const UPDATE_PRICING_ORDER="UPDATE_PRICING_ORDER,"
export const UPDATE_FACTORY="UPDATE_FACTORY"
export const UPDATE_TRADER="UPDATE_TRADER"
export const UPDATE_FINNCED="UPDATE_FINNCED"
//MAKTABTY SOCKET
export const UPDATE_CLIENT_STATUS="UPDATE_CLIENT_STATUS"
export const UPDATE_DRIVER_STATUS="UPDATE_DRIVER_ORDER"
export const UPDATE_NEW_ORDER="UPDATE_NEW_ORDER"